import { Action } from 'redux';

import { IFavoritableItemInfo } from '../../../ts/models/resourceInfoParts';
import { FavoriteItemType } from '../../../ts/ServerApi/types/IFavorite';
import { AddContentFavorite, ContentFavoriteAdded, ContentFavoriteRemoved, RemoveContentFavorite } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface AddContentFavoriteAction extends Action {
  item: IFavoritableItemInfo;
}

export function addContentFavorite(item: IFavoritableItemInfo): AddContentFavoriteAction {
  return {
    type: AddContentFavorite,
    item,
  };
}

export const isAddContentFavoriteAction = isActionFactory<AddContentFavoriteAction>(AddContentFavorite);

export interface ContentFavoriteAddedAction extends Action {
  item: IFavoritableItemInfo;
}

export function contentFavoriteAdded(item: IFavoritableItemInfo) {
  return {
    type: ContentFavoriteAdded,
    item,
  };
}

export const isContentFavoriteAddedAction = isActionFactory<ContentFavoriteAddedAction>(ContentFavoriteAdded);

export interface RemoveContentFavoriteAction extends Action {
  item: IFavoritableItemInfo;
}

export function removeContentFavorite(item: IFavoritableItemInfo):
    RemoveContentFavoriteAction {
  return {
    type: RemoveContentFavorite,
    item,
  };
}

export const isRemoveContentFavoriteAction = isActionFactory<RemoveContentFavoriteAction>(RemoveContentFavorite);

export interface ContentFavoriteRemovedAction extends Action {
  item: IFavoritableItemInfo;
}

export function contentFavoriteRemoved(item: IFavoritableItemInfo): ContentFavoriteRemovedAction {
  return {
    type: ContentFavoriteRemoved,
    item,
  };
}

export const isContentFavoriteRemovedAction = isActionFactory<ContentFavoriteRemovedAction>(ContentFavoriteRemoved);
